import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { arrow, autoUpdate, flip, FloatingArrow, FloatingPortal, offset, safePolygon, shift, useDelayGroup, useDismiss, useFloating, useFocus, useHover, useInteractions, useRole, useTransitionStatus, } from '@floating-ui/react';
import { cloneElement, useRef, useState } from 'react';
import { cx } from '~/common/utils';
import * as styles from './tooltip.module.scss';
import { useThemeContext } from '../../other';
export const Tooltip = ({ content, children, className, placement = 'top', fallbackPlacements = ['top', 'bottom', 'left', 'right'], delay = 300, noArrow = false, clickable = false, strategy = 'absolute', reference, }) => {
    const [open, setOpen] = useState(false);
    const arrowRef = useRef(null);
    const { context, refs, floatingStyles } = useFloating({
        placement,
        open: open && !!content,
        elements: {
            reference,
        },
        onOpenChange: setOpen,
        middleware: [offset(8), flip({ fallbackPlacements }), shift({ padding: 8 }), arrow({ element: arrowRef })],
        whileElementsMounted: autoUpdate,
        strategy,
    });
    const { delay: groupDelay, isInstantPhase } = useDelayGroup(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useHover(context, {
            // delayGroup
            delay: groupDelay === 0 ? { open: delay, close: 150 } : groupDelay,
            restMs: 40,
            handleClose: clickable ? safePolygon({ blockPointerEvents: true }) : undefined,
        }),
        useFocus(context),
        useRole(context, { role: 'tooltip' }),
        useDismiss(context),
    ]);
    const { isMounted, status } = useTransitionStatus(context, {
        duration: groupDelay || 250,
    });
    const theme = useThemeContext();
    return (_jsxs(_Fragment, { children: [reference === undefined &&
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                cloneElement(children, getReferenceProps({ ref: refs.setReference, ...children.props })), isMounted && (_jsx(FloatingPortal, { children: _jsxs("div", { ...getFloatingProps({
                        ref: refs.setFloating,
                        className: cx(styles.tooltip, className, theme),
                        style: floatingStyles,
                        onClick: () => setOpen(false),
                    }), "data-status": status, "data-instant": isInstantPhase, children: [!noArrow && (_jsx(FloatingArrow, { context: context, ref: arrowRef, width: 12, height: 6, className: styles.arrow, tipRadius: 2, strokeWidth: 1 })), content] }) }))] }));
};
